import { Icon, Link } from '@iwoca/orion';
import classnames from 'classnames';

import { TrustPilot } from '@src/components/TrustPilotBadge/TrustPilot';

import CheckmarkSVG from './Images/Checkmark';
import styles from './SidePanel.module.css';

const SidePanel = () => {
    return (
        <>
            <h2 className={styles.sidePanelHeader}>Business loans.</h2>
            <h2 className={styles.sidePanelHeader}>Simplified.</h2>
            <div className={styles.benefitsContainer}>
                <div className={styles.benefits}>
                    <CheckmarkSVG />
                    <p>24 hours to get a decision</p>
                </div>
                <div className={styles.benefits}>
                    <CheckmarkSVG />
                    <p>No fees for repaying early</p>
                </div>
                <div className={styles.benefits}>
                    <CheckmarkSVG />
                    <p>Only pay interest on the amount you withdraw</p>
                </div>
            </div>
            <TrustPilot theme="dark" className={styles.trustPilot} />
            <div className={styles.contacts}>
                <Link href="tel:+442037780274" className={styles.contactIcons}>
                    <Icon
                        icon="phoneFilled"
                        className={classnames(
                            styles.contactIcon,
                            styles.phoneIcon
                        )}
                    />{' '}
                    <span>020 3778 0274</span>
                </Link>
                <Link
                    href="mailto:contact@iwoca.co.uk"
                    className={styles.contactIcons}>
                    <Icon
                        icon="emailFilled"
                        className={classnames(
                            styles.contactIcon,
                            styles.emailIcon
                        )}
                    />
                    <span>contact@iwoca.co.uk</span>
                </Link>
            </div>
        </>
    );
};

export default SidePanel;
